module.exports = __webpack_public_path__ + "img/home-bg-1.3bb29712.png";